<template>
  <div class="lc">
    <div class="lt-left">
    </div>
    <div ref="cmain1" class="cmain" :style="{ width: '480px', height: '320px' }"></div>

  </div>
</template>

<script>

export default {
  name: 'template.leftCent',
  data() {
    return {
      myChart: "",
      option: "",
      TmyChart: "",
      Toption: "",
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    cDrawCircle() {
      var echarts = require('echarts');
      var TmyChart = echarts.init(this.$refs.cmain1);
      let data = [
        { value: 1700, name: '老会员', itemStyle: { color: '#004cc8 ' } },
        { value: 580, name: '非会员', itemStyle: { color: '#fff' } },
        { value: 1800, name: '新会员', itemStyle: { color: '#00d9ff' } },

      ];
      var Toption = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',  //文字 行 排放 默认列
          top: '30%',
          right: 70,
          itemHeight: 15,    //图例的高度  文字左边那个
          itemWidth: 15,
          z: 5,
          textStyle: {
            //设置文本样式
            color: "#CBD8DE",
            lineHeight: 32,
            fontWeight: '400',
            fontSize: '14',
            // padding: [0, 0, 0, 10],
            rich: {
              a: {
                padding: [0, -20, 0, 10],
                fontSize: 14,
              },
              b: {
                padding: [0, 0, 0, 28],
                fontSize: 14,
                color: '#00D9FF'
              },
            }

          },         //图例的高度
          formatter: function (name) {
            let arr = [
              '{a|' + name + '}',
              '{b|' + '00' + '%}',
            ]
            return arr.join("    ")
          }


          // rich:{
          //   a:{
          //     left:20
          //   }
          // }

        },
        series: [
          {
            type: 'pie',
            //选中ple的中间40-50
            center: ['24%', '50%'],
            radius: ['40%', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            data: data,

          }
        ]
      };
      Toption && TmyChart.setOption(Toption);
      setInterval(function () {
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000)
    },
  },
  mounted() {
    this.$nextTick(() => {

      this.cDrawCircle(); //需要刷新的数据
    });
  },
};
</script>

<style scoped lang="scss">
.lc {
  width: 480px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;

  //  background: pink;
}

.lt-left {
  width: 198.5px; //+20
  height: 160.5px;
  margin: 33px 0 0 17px;

  box-sizing: border-box;
  // width: 397px;
  // height: 321px;
  background: url('../../assets/template/piebg.png') no-repeat;
  background-size: 100%;

  z-index: 1;
}

.cmain {
  position: absolute;
  top: -35px;
  // left: -163px;
  z-index: 5;
}


.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 14px;
}
</style>